(function ($) {

    $.fn.contentPaper = function () {

        this.each((i, el) => {
            const $self = $(el);

            
            
            const $paperNavigation = $self.find('.paper-navigation');
            const $paperNavigationToggle = $paperNavigation.find('.paper-navigation-toggle');
            const $paperNavigationPages = $paperNavigation.find('.paper-nav-page-title');
            const $paperNavigationSubpages = $paperNavigation.find('.paper-nav-subpage-title');
            const $paperPagination = $self.find('.paper-pagination');
            const $paperPaginationContent = $paperPagination.find('.paper-pagination-content');
            const $paperPaginationPages = $paperPagination.find('.paper-pagination-page');
            const $paperContent = $self.find('.paper-content');
            const $sourcesCited = $paperNavigation.find('#sources-cited');
            let   $tooltips = $paperContent.find('.fr-custom-tooltip');
            let   $definitionTooltips = $paperContent.find('.fr-definition-tooltip');
            const $spinnerContainer = $self.find('.page-content-spinner');
            const $header = $('body > .banner');

            let ajaxConfig = JSON.parse($self.attr('ajax-config'));
            let paginationSlider;
            let currentPage;
            const siteURL = $paperContent.attr('data-site-url');
            const paperSlug = $paperContent.attr('data-paper-slug');

            const sources_cited_id = 'sources_cited';
            const sources_cited_url_slug = 'sources-cited';

            $paperNavigationToggle.on('click', () => {
                $paperNavigation.toggleClass('expanded');
            });

            $paperNavigationPages.on('click', (e, [scroll] = [true]) => {
                const $page = $(e.target);
                if($page.attr('data-sublevel') == '0' && scroll == true){
                    collapsePaperNavigation();
                    scrollToAnchor($page.attr('data-page-id'), $page);
                }else{
                    const page_id = $page.attr('data-page-id');
                    pageClick(page_id);
                }
            });

            $paperNavigationSubpages.on('click', (e, [scroll] = [true]) => {
                const $subpage = $(e.target);

                collapsePaperNavigation();

                if(scroll == true){
                    scrollToAnchor($subpage.attr('data-page-id'), $subpage);
                }else{
                    ajaxConfig.page_id = $subpage.attr('data-page-id');
                    loadPaperPage(ajaxConfig);
                }
            });

            function pageClick(page_id){
                ajaxConfig.page_id = page_id;
                collapsePaperNavigation();
                /** If same as current page just scroll to top of the page and update URL */
                if(ajaxConfig.page_id == currentPage){
                    updateURL();
                }else{
                    updatePagination(page_id);
                    loadPaperPage(ajaxConfig);
                }
                window.scrollTo(0, 0);
            }

            function scrollToAnchor(page_id, $subpage){
                const parent_page_id = page_id;
                const anchor_id = $subpage.attr('data-id');
                if(currentPage == parent_page_id){
                    goToSubpage(anchor_id);
                    /** Update browser URL */
                    updateURL(anchor_id);
                }else{
                    ajaxConfig.page_id = parent_page_id;
                    loadPaperPage(ajaxConfig, anchor_id);
                }
            }

            function collapsePaperNavigation(){
                $paperNavigation.removeClass('expanded');
            }

            const loadPaperPage = (ajaxConfig, anchor_id = '') => {

                emptyPageContent();

                $spinnerContainer.css('display', '');

                setCurrentPage(ajaxConfig.page_id);
                
                /** Update browser URL */
                updateURL(anchor_id);

                if(ajaxConfig.page_id == sources_cited_id){
                    const page_title = $paperNavigationPages.filter('[data-page-id="' + sources_cited_id + '"]').text();
                    $paperContent.find('.page-title').text(page_title);
                    $paperContent.find('.page-content').html('<ol class="' + sources_cited_url_slug + '">' + $sourcesCited.find('ol').html() + '</ol>');
                    hideSpinner();
                }else{
                    updatePagination(ajaxConfig.page_id);
                    doAjax(ajaxConfig, (response) => {
                        if (response.success) {
                            $paperContent.find('.page-title').text(response.data.title);
                            $paperContent.find('.page-content').html(response.data.content);
    
                            /** Go to subpage if applicable */
                            if(anchor_id.length > 0){
    
                                setTimeout(() => {
                                    goToSubpage(anchor_id);
                                }, 500);
                                
                            }
                        }
    
                        reinitializeTooltips();
    
                        //reset
                        hideSpinner();
                    });
                }

            }

            function imagesLoaded(){
                const $images = $paperContent.find('img');
                $images.each((i, img) => {
                    if(!img.complete || img.naturalHeight == 0){
                        return false;
                    }
                });
                return true;
            }

            const doAjax = (config, callback) => {
                let response = { success: false, data: [] };

                let configObject = {
                    action: config.action,
                    page_id: config.page_id,
                };

                let configString = Object.keys(configObject).map(key => key + '=' + configObject[key]).join('&');

                let urlWithParameters = config.url + '?' + configString;
                
                
                window.fetch(urlWithParameters, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        if (data.success) {
                            response.data = data.data;
                            response.success = data.success;
                        }
                        callback(response);
                    })
                    .catch(function (err) {
                        $spinnerContainer.hide();
                        console.log('There was an error processing your search, please try again later.', err);
                    });
            }

            function emptyPageContent(){
                $paperContent.find('.page-title').text('');
                $paperContent.find('.page-content').html('');
            }

            function initPaginationSlider(){
                var offsetCorrection = $('html').width() < window.innerWidth ? ((window.innerWidth - $('html').width()) / 2) * -1 : 0;
                
                $paperPagination.css('left', offsetCorrection);

                let page_ids = [];
                
                $paperNavigationPages.each((i, el) => {
                    const page_id = $(el).attr('data-page-id');
                    page_ids.push(page_id);
                });

                page_ids = $.unique(page_ids);

                paginationSlider = new window.Splide( $paperPagination.find('.splide')[0], {
                    type        : 'slide',
                    perPage     : page_ids.length > 6 ? 6 : page_ids.length,
                    //perPage     : 6,
                    perMove     : 1,
                    autoplay    : false,
                    interval    : 0,
                    speed       : 200,
                    easing      : 'linear',
                    arrows: false,
                    pagination: false,
                    drag: false,
                    focus: true,
                } ).mount();

                if(page_ids.length > 1) $paperPagination.attr('data-pages-count', page_ids.length);

                /** Go to previous page */
                $paperPagination.on('click', '.arrow-prev', () => {
                    const index = $paperPaginationPages.filter('.is-active').attr('data-index');
                    if(index > 0){
                        const page_id = $paperPaginationPages.eq(parseInt(index) - 1).attr('data-page-id');
                        goToPage(page_id, false);
                    }
                });

                /** Go to next page */
                $paperPagination.on('click', '.arrow-next', () => {
                    const index = $paperPaginationPages.filter('.is-active').attr('data-index');
                    if(index < $paperPaginationPages.length){
                        const page_id = $paperPaginationPages.eq(parseInt(index) + 1).attr('data-page-id');
                        goToPage(page_id, false);
                    }
                });

                /** Page click */
                $paperPaginationPages.on('click', 'span', (e) => {
                    const $clickedPage = $(e.target).parent('.paper-pagination-page');
                    const page_id = $clickedPage.attr('data-page-id');
                    goToPage(page_id, false);
                });

                /**
                 * Initial page
                 * 
                 * If no initial page specified then first page is the initial page
                 * If 'sources-cited' is specified as initial page then select last page as initial page
                 */
                const $initial_page = $paperPaginationPages.filter('.initial-index');
                const initial_page_id = $initial_page.length > 0 ? $initial_page.attr('data-page-id') : ($paperPaginationContent.attr('initial-index') == sources_cited_url_slug ? sources_cited_id : $paperPaginationPages.eq(0).attr('data-page-id'));

                if(initial_page_id == sources_cited_id){
                    $paperNavigationPages.filter('[data-page-id="' + sources_cited_id + '"]').trigger('click');
                }else{
                    setCurrentPage(initial_page_id);
                    updatePagination(initial_page_id);
                }
            }

            function updatePagination(page_id){
                paginationSlider.go(getPageIndex(page_id));
            }

            function goToPage(page_id, scroll = true){
                let $pageLink = $paperNavigationPages.filter('[data-page-id="' + page_id + '"]');
                if($pageLink.length == 0){
                    $pageLink = $paperNavigationSubpages.filter('[data-page-id="' + page_id + '"]');
                    if($pageLink.length > 0){
                        $pageLink.trigger('click', [false]);
                    }else{
                        /** If no "$pageLink" force page load */
                        pageClick(page_id);
                    }
                }else{
                    $pageLink.trigger('click', [scroll]);
                }
                setCurrentPage(page_id);
            }

            function goToSubpage(anchor_id){
                if(imagesLoaded()){
                    const $targetElement = $('#'+anchor_id);
                    const heightFix = $header.outerHeight();
                    window.scrollTo(0, $targetElement.offset().top - heightFix - 30);
                }else{
                    goToSubpage(anchor_id);
                }
            }

            function setCurrentPage(page_id){
                currentPage = page_id;
            }

            function updateURL(hash = ''){
                if(currentPage == sources_cited_id){
                    const newURL = siteURL + '/paper/' + paperSlug + '/' + sources_cited_url_slug + '/';
                    window.history.replaceState(null, null, newURL);
                }else{
                    const page_number = getPageIndex(currentPage) + 1;
                    const newURL = siteURL + '/paper/' + paperSlug + '/' + page_number + '/' + (hash.length > 0 ? '#' + hash : '');
                    window.history.replaceState(null, null, newURL);
                }
            }

            function getPageIndex(page_id){
                return $paperPaginationPages.filter('[data-page-id="' + page_id + '"]').index();
            }

            function addTooltipsIndexes(){
                const initial_tooltip_index = $sourcesCited.length == 0 ? 0 : $sourcesCited.find('li').filter('[data-tooltip-page-id="'+currentPage+'"]').first().index();

                $tooltips.each((i, tooltip) => {
                    const tooltipIndex = initial_tooltip_index + i + 1;
                    
                    $(tooltip).attr('tooltip-index', tooltipIndex);
                    if(tooltipIndex && tooltipIndex.toString().length > 2) $(tooltip).addClass('oval-tooltip');
                    $(tooltip).show();
                });
            }

            function hideSpinner(){
                $spinnerContainer.hide();
            }

            function reinitializeTooltips(){
                /** Init new tooltips */
                $tooltips = $paperContent.find('.fr-custom-tooltip');
                $definitionTooltips = $paperContent.find('.fr-definition-tooltip');
                
                $tooltips.customTooltip();
                $definitionTooltips.definitionTooltip();

                /** Update Tooltip Indexes */
                addTooltipsIndexes();
            }

            function checkSourcesCitedLinks(){
                const $links = $sourcesCited.find('a');
                addHTTPS($links);
                if($paperContent.find('.sources-cited').length > 0){
                    addHTTPS($paperContent.find('.sources-cited a'));
                }
            }

            function addHTTPS($links){
                $links.each((i, el) => {
                    const $el = $(el);
                    if($el.attr('href').startsWith('www')){
                        $el.attr('href', 'https://' + $el.attr('href'));
                    }
                });
            }

            if($paperPagination.length > 0) initPaginationSlider();

            addTooltipsIndexes();

            checkSourcesCitedLinks();

            /** Collapse paper navigation on click */
            $(document).on('click', (e) => {
                if($(e.target).closest('.paper-navigation').length == 0){
                    collapsePaperNavigation();
                }
            });

        });

        return this;
    }

    $(() => {
        $('.entry-content-paper').contentPaper();
    });

})($);


// WEBPACK FOOTER //
// ./scripts/partials/content-paper.js